export const unknownReturnTypeError = new Error('unknown returnType')
export const unknownThresholdTypeError = new Error('unknown thresholdType')
